<script>
import CustomDictTag from '@/components/DictCustomTag/index.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'
import { withdrawalRecordsPageUserDetail } from '@/api/biz/userDetail'

export default {
  name: 'WithdrawalRecordsTable',
  components: { CustomDictTag },
  mixins: [tableMixin],
  props: {
    userId: undefined
  },
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('ID'),
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: this.$t('收款人信息'),
          dataIndex: 'userNickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('账户类型'),
          dataIndex: 'withdrawType',
          scopedSlots: { customRender: 'withdrawType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('收款二维码'),
          dataIndex: 'qrCode',
          align: 'center'
        },
        {
          title: this.$t('提现金额'),
          dataIndex: 'amount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('手续费'),
          dataIndex: 'fee',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('到账金额'),
          dataIndex: 'realAmount',
          scopedSlots: { customRender: 'realAmount' },
          align: 'center'
        },
        {
          title: this.$t('审核状态'),
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: this.$t('审核时间'),
          dataIndex: 'arriveTime',
          scopedSlots: { customRender: 'arriveTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('转账状态'),
          dataIndex: 'payStatus',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('申请时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    userId(newVal) {
      this.getList()
    }
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    getList() {
      if (!this.userId) {
        return
      }
      this.loading = true
      this.queryParam.id = this.userId
      withdrawalRecordsPageUserDetail(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    }
  }
}
</script>

<template>
  <a-card>
    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :bordered="tableBordered"
      :scroll="{ x: '160%' }"
    >
      <span slot="changeType" slot-scope="text, record">
        <custom-dict-tag :options="customDict.AccountChangeTypeEnum" :color="true" :color-array="['green', 'red']" :value="record.changeType" />
      </span>
      <span slot="payType" slot-scope="text, record">
        <custom-dict-tag :options="customDict.PayTypeEnum" :color="true" :value="record.payType" />
      </span>
      <span slot="billType" slot-scope="text, record">
        <custom-dict-tag :options="customDict.UserBalanceTypeEnum" :color="true" :value="record.billType" />
      </span>
      <span slot="arriveTime" slot-scope="text, record">
        {{ parseTime(record.arriveTime) }}
      </span>
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
      <span slot="realAmount" slot-scope="text, record">
        {{ (Number(record.amount) - Number(record.fee)).toFixed(2) }}
      </span>
    </a-table>
    <!-- 分页 -->
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :pageSizeOptions="pageSizeOptions"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => getTotal(total)"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-card>
</template>

<style scoped lang="less">

</style>
